import React, { StatelessComponent } from 'react';

import Rect from '@components/rect';

const CustomPageStub: StatelessComponent = () => {
    return (
        <div className="block centering">
            <Rect width={150} height={30} type="black" />
            <br />
            <Rect height={30} />
            <br />
            <Rect height={30} />
            <br />
            <Rect height={30} />
        </div>
    );
};

export default CustomPageStub;
